<template>
  <div class="d-flex">
    <div class="summary-label colorNeutralsNavy500--text">{{ label }}</div>
    <div class="summary-value colorNeutralsNavy400--text"><slot /></div>
  </div>
</template>

<script>
export default {
  name: "VendorSummaryProperty",
  props: ["label"]
};
</script>

<style scoped>
.summary-label {
  width: 140px;
  font-weight: bold;
}
.summary-value {
  max-width: 220px;
}
</style>
